/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { settingsActualConfig } from '../../config/settings.config';
export interface ISettingsActualPluginMethods extends IPluginMethodMap {
  getSettingsActualSync(args?: any): any;
}

export class SettingsActualPlugin implements IAgentPlugin {
  readonly methods: ISettingsActualPluginMethods;

  constructor() {
    this.methods = {
      getSettingsActualSync: this.getSettingsActualSync.bind(this),
    };
  }

  getSettingsActualSync(args?: any) {
    return {
      settings: settingsActualConfig,
    };
  }
}
